<!--单位信息模块,暂时隐藏了右边部分，需要重新设计-->
<template>
	<div class="usePowerUnitDiv">
		<div class="topLeftTitleContent">统计信息（单位：kW·h）</div>
		<div class="userPowerContent bodyBorder">
			<div class="left">
				<powerValueView class="powerValueView"></powerValueView>
				<div class="barChart">
					<vchart ref='vchartBar'></vchart>
				</div>
			</div>
			<div class="right">
				<div class="monthPowerTop">
					<vchart ref='vchartBarTop1'></vchart>
				</div>
				<div class="monthPowerGrowTop" v-if="false">
					<vchart ref='vchartBarTop2'></vchart>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	import vchart from '@/components/module/chart/vchart.vue'
	import powerValueView from '@/page/projectDingZhi/quanSheng/powerValueView.vue'
	export default {
		components: {
			vchart,
			powerValueView,
		},
		props: [],
		data() {
			return {
				barOption: {
					xAxis: [{
						type: 'category',
						data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
							'20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'
						],
						axisLabel: {
							textStyle: {
								color: '#ffffff',
							},
						},
						splitLine: {
							lineStyle: {
								type: 'dashed',
								color: '#6f7284'
							}
						},
					}],
					yAxis: [{
						title: '能耗值（KWH）',
						type: 'value',
						axisLabel: {
							textStyle: {
								color: '#ffffff',
							},
						},
						splitLine: {
							lineStyle: {
								type: 'dashed',
								color: '#6f7284'
							}
						},
					}],
					legend: {
						x: 'left',
						y: 'top',
						padding: [0, 0, 0, 50],
						bottom: '5px',
						data: ['电量', '电费'],
					},
					backgroundColor: '',
					tooltip: {
						trigger: 'axis',
						confine: true,
						formatter: (params, ticket, callback) => {
							var nowMonth = new Date().getMonth() + 1
							var label = '日用电量统计</br>' + nowMonth + '月' + params[0].axisValue + " 日</br>"
							params.forEach(item => {
								var values;
								if(this.$historyTools.isNull(item.data)) {
									values = "无采集数据";
								} else {
									values = cutDigital(item.data);
								}
								label += item.seriesName + " : " + values + "</br>"
							})
							return label;
						},
						axisPointer: {
							animation: false
						}
					},
					grid: {
						height: '80%',
						left: '1%',
						right: '0',
						bottom: '0%',
						top: '20%',
						containLabel: true
					},
					series: []
				},
				top1BarOption: {
					title: {
						text: '月用电量TOP10排行',
						left: '40%',
						top: '5%',
						textStyle: {
							color: '#FFFFFF',
							align: "center"
						}
					},
					grid: {
						left: '25%',
						right: '10%',
						bottom: '3%',
						top: '20%'
					},
					xAxis: {
						show: false,
						type: 'value',

					},
					yAxis: {
						type: 'category',
						axisLine: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: '#007eca'
							},
							fontSize: 11
						},
						data: []
					},
					series: []
				},
				top2BarOption: {
					title: {
						text: '月用电增幅TOP5',
						left: '40%',
						top: '1%',
						textStyle: {
							color: '#FFFFFF',
							align: "center"
						}
					},
					grid: {
						left: '20%',
						right: '4%',
						bottom: '0',
						top: '15%'
					},
					xAxis: {
						show: false,
						type: 'value',

					},
					yAxis: {
						type: 'category',
						axisLine: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: '#007eca',

							},
							fontSize: 11
						},
						data: []
					},
					series: []
				},
				powerDateList: {},
				monthPowerIncreaseList: [],
				monthIncreaseList: [],

			}
		},
		created() {},
		mounted() {
			this.$refs.vchartBar.setData(this.barOption)
			this.powerDate()
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
		},
		watch: {
			powerDateList(nv, ov) {
				var money = []
				var power = []
				if(!isempty(nv)) {
					Object.keys(nv).forEach(key => {
						var pw = nv[key]['总电量']
						var my = nv[key]['总电费']
						if(this.$historyTools.isNull(my)) {
							my = undefined
						}
						if(this.$historyTools.isNull(pw)) {
							pw = undefined
						}
						money.push(my)
						power.push(pw)
					})
				}
				this.barOption.series = [{
					name: '电量',
					type: 'bar',
					itemStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(
								0, 0, 0, 1, [{
										offset: 0, 
										color: '#005ae1'
									},
									{
										offset: 1,
										color: '#34abff'
									}
								]
							)
						},
						emphasis: {
							color: new echarts.graphic.LinearGradient(
								0, 0, 0, 1, [{
										offset: 0, 
										color: '#00c6ff'
									},
									{
										offset: 1,
										color: '#34abff'
									}
								]
							)
						}
					},
					data: power
				}, {
					name: '电费',
					type: 'bar',
					itemStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(
								0, 0, 0, 1, [{
										offset: 0, 
										color: '#ffd200'
									},
									{
										offset: 1,
										color: '#e68b11'
									}
								]
							)
						},
						emphasis: {
							color: new echarts.graphic.LinearGradient(
								0, 0, 0, 1, [{
										offset: 0, 
										color: '#ff8400'
									},
									{
										offset: 1,
										color: '#ffd200'
									}
								]
							)
						}
					},
					data: money
				}]
				this.$refs.vchartBar.setData(this.barOption)
			},
			monthPowerIncreaseList(nv, ov) {
				if(!isempty(nv)) {
					var seriesData = []
					var yData = []
					nv.forEach(e => {
						yData.push(e.deviceName)
						seriesData.push(e.differenceValue)
					})
					if(yData.length < 5) {
						var b = 5 - yData.length
						for(var i = 0; i < b; i++) {
							yData.push(" ")
							seriesData.push('')
						}
					}
					this.top1BarOption.series = [{
						name: '用电量',
						type: 'bar',
						barMaxWidth: '50%',
						itemStyle: {
							color: '#0c9326'
						},
						label: {
							normal: {
								show: true,
								formatter: '{c}KWh',
								color: '#fff',
								position: 'insideLeft',
							},
							fontSize: 10
						},
						data: this.getReverse(seriesData)
					}]
					this.top1BarOption.yAxis.data = this.getReverse(yData)
				} else {
					this.top1BarOption.series = []
					this.top1BarOption.yAxis.data = []
				}
				this.$refs.vchartBarTop1.setData(this.top1BarOption, true)
			},
			monthIncreaseList(nv, ov) {
				var seriesData = []
				var yData = []
				if(!isempty(nv)) {
					nv.forEach(e => {
						yData.push(e.deviceName)
						if(e.lastMonth != 0 && e.thisMonth - e.lastMonth != 0) {
							seriesData.push(((e.thisMonth - e.lastMonth) / e.lastMonth * 100).toFixed(2))
						} else {
							seriesData.push(0)
						}
					})
					if(yData.length < 5) {
						var b = 5 - yData.length
						for(var i = 0; i < b; i++) {
							yData.push(' ')
							seriesData.push('')
						}
					}
				}
				this.top2BarOption.series = [{
					name: '用电量增幅',
					type: 'bar',
					barMaxWidth: '50%',
					itemStyle: {
						color: '#eb6716'
					},
					label: {
						normal: {
							show: true,
							formatter: '{c}%',
							color: '#fff',
							position: ['90%', '0%'],
						},
						fontSize: 11
					},
					data: this.getReverse(seriesData)
				}]
				this.top2BarOption.yAxis.data = this.getReverse(yData)
				// this.$refs.vchartBarTop2.setData(this.top2BarOption)
			},
			nowUnit(nv, ov) {
				this.powerDate()
				this.monthPowerIncrease()
				this.monthIncrease()
			}
		},
		methods: {
			powerDate() {
				if(!isempty(this.nowUnit.id)) {
					this.powerDateList = []
					var id = this.nowUnit.id
					this.$api.powerApi.getClassPGByMonthForHuaPu(new Date().getTime(), this.nowUnit.id, respon => {
						if(id == this.nowUnit.id) { //接口延迟时 只赋值当前的unit结果
							this.powerDateList = respon
						}
					})
				}
			},
			monthPowerIncrease() {
				this.monthPowerIncreaseList = []
				var dateMonth = new Date().formatByMonth()
				this.$api.powerApi.getPowerDifferenceRanking(this.nowUnit.id, new Date(dateMonth + '/01 00:00:00').getTime(), new Date()
					.getTime(), 10, respon => {
						this.monthPowerIncreaseList = respon
					})
			},
			//月用电增幅
			monthIncrease() {
				this.monthIncreaseList = []
				this.$api.powerApi.getMonthDifferenceRanking(this.nowUnit.id, new Date().getTime(), 5, respon => {
					this.monthIncreaseList = respon
				})
			},
			getReverse(data) {
				var dataList = []
				if(!isempty(data)) {
					var dataLength = data.length - 1
					data.forEach(e => {
						dataList[dataLength] = e
						dataLength--
					})
				}
				return dataList

			}

		}
	}
</script>

<style scoped>
	@import url("../../../components/css/usePowerUnit.css");
	.barChart {
		width: 97%;
		height: 60%;
	}
	
	.barChart>>>.default-chart {
		height: 100%;
		width: 100%;
	}
	
	.monthPowerTop>>>.default-chart {
		height: 100%;
		width: 100%;
	}
	
	.monthPowerGrowTop>>>.default-chart {
		height: 100%;
		width: 100%;
	}
	
	.powerValueView {
		height: 30%;
		margin-top: 10px;
	}
	
	.usePowerUnitDiv {
		height: 320px;
		width: 100%;
	}
	
	.userPowerContent {
		display: flex;
		font-size: 9px;
		display: flex;
		justify-content: space-between;
		height: calc(100% - 31px);
	}
	
	.left {
		width: 100%;
		height: 100%;
		flex-wrap: wrap;
		display: flex;
		justify-content: space-around;
		flex-direction: column;
	}
	
	.right {
		display: none;
		width: 37%;
		height: 100%;
	}
	
	.monthPowerTop {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
	}
	
	.monthPowerGrowTop {
		width: 100%;
		height: 50%;
	}
</style>